<template>
  <div class="ai-list" v-loading="loading">
    <div class="con-body">
      <el-table :data="tableData">
        <el-table-column prop="created_at" :label="$t('new_ai.created_at')"  width="180"></el-table-column>
        <el-table-column :label="$t('new_ai.file_name')">
          <template slot-scope="scope">
            <div @click="picView(baseUrl+scope.row.file_name)"
              class="small-img"><img :src="baseUrl+scope.row.file_name" /></div>
          </template>
        </el-table-column>
        <el-table-column prop="file_size" :label="$t('new_ai.file_size')" ></el-table-column>
        <el-table-column prop="file_type" :label="$t('new_ai.file_type')" ></el-table-column>
        <el-table-column prop="width" :label="$t('new_ai.width')" ></el-table-column>
        <el-table-column prop="height" :label="$t('new_ai.height')" ></el-table-column>
        <el-table-column prop="md5_hash" :label="$t('new_ai.md5_hash')" ></el-table-column>
        <el-table-column :label="$t('new_ai.status')">
          <template slot-scope="scope">
            <span v-if="scope.row.status===2" :class="'status'+scope.row.status">{{ scope.row.error_message }}</span>
            <span v-else :class="'status'+scope.row.status">{{$t('new_ai.status_text')[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('new_ai.result')" fixed="right" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status===1" class="blue" @click="viewsResult(scope.row.id, baseUrl+scope.row.file_name)">{{$t('new_ai.views')}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="$t('new_ai.result')"
      class="dialog600 ai-dbox"
      :visible.sync="infoOneVibity"
      v-if="infoOneVibity"
      :before-close="closeOne"
    >
      <div class="img_left"><img :src="sourceUrl"></div>
      <div class="text_rgt">
        <p>{{$t('new_ai.con.age')}}：<span>{{infoData.age.value}}</span></p>
        <p>{{$t('new_ai.con.age_group')}}：<span>{{$t('new_ai.con.age_group_arr')[infoData.age.age_group]}}</span></p>
        <p>{{$t('new_ai.con.gender')}}：<span>{{infoData.gender.value}}</span></p>
        <p>{{$t('new_ai.con.glass')}}：<span>{{$t('new_ai.con.glass_arr')[infoData.glass.value]}}</span></p>
        <p>{{$t('new_ai.con.mask')}}：<span>{{$t('new_ai.con.mask_arr')[infoData.mask.value]}}</span></p>
        <p>{{$t('new_ai.con.hat')}}：<span>{{$t('new_ai.con.hat_arr')[infoData.hat.value]}}</span></p>
        <p class="small-title">{{$t('new_ai.con.face_iqa.name')}}</p>
        <p>{{$t('new_ai.con.face_iqa.points_quality')}}：<span>{{ infoData.face_iqa.points_quality }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.eye_distance')}}：<span>{{ infoData.face_iqa.eye_distance }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.colorful')}}：<span>{{ infoData.face_iqa.colorful }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.gray_scale')}}：<span>{{ infoData.face_iqa.gray_scale }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.gray_mean')}}：<span>{{ infoData.face_iqa.gray_mean }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.gray_var')}}：<span>{{ infoData.face_iqa.gray_var }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.clearity')}}：<span>{{ infoData.face_iqa.clearity }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.pose_pitch')}}：<span>{{ infoData.face_iqa.pose_pitch }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.pose_yaw')}}：<span>{{ infoData.face_iqa.pose_yaw }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.uncovered')}}：<span>{{ infoData.face_iqa.uncovered }}</span></p>
        <p>{{$t('new_ai.con.face_iqa.total_quality')}}：<span>{{ infoData.face_iqa.total_quality }}</span></p>

      </div>
      <div class="clear"></div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="closeOne"
          >{{$t('new_ai.close')}}</el-button
        >
      </div>
    </el-dialog>


    <el-image-viewer
        v-if="picData.showViewer"
        :on-close="closePic"
        :url-list="picData.picUrl" />


  </div>
</template>

<script>
import aiApi from "@/api/ai/aiList"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    ElImageViewer
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API+"/static/upload/face/",
      loading: false,
      tableData: [],
      pageInfo: {
        status: 0,
        file_type:1,
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      picData: {
        showViewer: false,
        picUrl: []
      },
      sourceUrl: '',
      infoOneVibity: false,
      infoData: {
        id: "",
        face_token: "",
        request_id: "",
        location: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        age: {
          range: 0,
          value: 0,
          age_group: 0
        },
        gender: {
          confidence: 0,
          value: ""
        },
        glass: {
          confidence: 0,
          has: false,
          value: 0
        },
        mask: {
          confidence: 0,
          value: 0
        },
        beard: {
          confidence: 0,
          value: 0
        },
        hat: {
          confidence: 0,
          value: 0
        },
        smile: {
          confidence: 0,
          value: 0
        },
        face_iqa: {
          points_quality: 0,
          eye_distance: 0,
          colorful: 0,
          gray_scale: 0,
          gray_mean: 0,
          gray_var: 0,
          clearity: 0,
          pose_pitch: 0,
          pose_yaw: 0,
          uncovered: 0,
          total_quality: 0
        },
        face_mark: {
          left_eye: { x: 0, y: 0 },
          right_eye: { x: 0, y: 0 },
          left_mouth: { x: 0, y: 0 },
          right_mouth: { x: 0, y: 0 },
          nose_tip: { x: 0, y: 0 }
        },
        create_time: "",
        update_time: ""
      },
      timerNew: null
    }
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      aiApi.getImageList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    viewsResult(id, url) {
      this.sourceUrl = url;
      aiApi.getFaceResult({ id }).then((res) => {
        console.log('getFaceResult', res.data)
        if (res.data.code === 1000) {
          this.infoData = res.data.data;
          this.infoOneVibity = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closeOne() {
      this.getTableData(this.pageInfo.page);
      this.infoOneVibity = false
    },
    picView(url) {
      this.picData.picUrl[0] = url
      this.picData.showViewer = true
    },
    closePic() {
      this.picData.showViewer = false
      this.picData.picUrl = []
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
    if (this.timerNew) {
      clearInterval(this.timerNew)
    } else {
      this.timerNew = setInterval(() => {
        this.getTableData(this.pageInfo.page);
      }, 500 * 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timerNew)
    this.timerNew = null
  }
};
</script>

<style lang='less' scoped>
.ai-list{
  .small-img{
    width: auto;
    height: 80px;
    cursor: pointer;
    img{
      width: auto;
      height: 80px;
    }
  }
  .status0{
    color: #f39c12;
  }
  .status1{
    color: rgba(26, 151, 14, 0.856);
  }
  .status2{
    color: rgba(241, 12, 4, 0.856);;
  }

  .img_left{
    width:180px;float:left;
    img{
      max-width: 100%;
    }
  }
  .text_rgt{
    width:350px;float:right;
    p{
      margin:0;
      color:#666;
      line-height: 27px;
      span{
        color:#333;
        margin-left: 5px;
      }
    }
    .small-title{
      margin-top: 10px;
      font-size: 16px;
      color: #333;
    }
  }
}

</style>
